import React, { useState, useEffect, Fragment, useRef } from "react";
import {
  Select,
  Form,
  Input,
  Button,
  Modal,
  Upload,
  Row,
  Col,
  DatePicker,
  message,
  InputNumber,
  Space,
  Radio,
  TreeSelect,
  Tree,
} from "antd";
// import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from "@api/role";
import ResourceApi from "@api/resource";
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from "@components/Modal";
import { treeConversion, treeIds, extraIds } from "@utils/common";
// import moment from 'moment';
// const { UPLOADER } = window.globalConfig;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option;
export default ({ title, visible, formData = null, cancel, roleText = [] }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false);
  const [resourceTree, setResourceTree] = useState();
  const [formValue, setFormValue] = useState();
  const [loading, setLoading] = useState();
  const [allIds, setAllIds] = useState([]);

  useEffect(() => {
    list();
    return () => {};
  }, []);

  useEffect(() => {
    if (visible && formData !== null) {
      const ids = [];
      formData.resourceIds.split(",").forEach((item) => {
        if (item) {
          ids.push(item);
        }
      });
      setFormValue({
        roleType: 1,
        type: 1,
        ...formData,
        resourceIds: ids.filter((v) => treeIds.id.includes(v)),
      });
      setEditBool(true);
    } else {
      setFormValue({
        roleType: 1,
        type: 1,
      });
      setEditBool(false);
    }
  }, [visible]);

  const list = () => {
    ResourceApi.getResourceAllForTree().then((res) => {
      if (res.status == 0) {
        setResourceTree(
          res.data.map((v, i) => {
            return treeConversion(v.children);
          }),
        );
      }
    });
  };

  const submit = () => {
    form.validateFields().then((values) => {
      if (!values) {
        return;
      }
      setLoading(true);
      if (formData) {
        RoleApi.update(
          {
            ...values,
            id: formData.id,
            resourceIds:
              allIds.length > 0 ? allIds : values.resourceIds.join(","),
          },
          { headers: { deptPath: values.deptPath } },
        )
          .then((res) => {
            setLoading(false);
            if (res.status == 0) {
              message.success("编辑成功");
              handelCancel();
              cancel(true);
            }
          })
          .catch((err) => {
            setLoading(false);
          });
        return;
      }
      RoleApi.create(
        {
          ...values,
          resourceIds:
            allIds.length > 0 ? allIds : values.resourceIds.join(","),
        },
        { headers: { deptPath: values.deptPath } },
      )
        .then((res) => {
          if (res.status == 0) {
            message.success("新建成功");
            form.resetFields();
            cancel(true);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };
  const handelCancel = () => {
    form.resetFields();
    cancel(false);
  };

  const handleChange = (values, label, extra) => {
    if (extra) {
      let ids = [...new Set(extraIds(extra.allCheckedNodes).flat(Infinity))];
      setAllIds(ids.join(","));
    } else {
      setAllIds("");
    }
  };
  const onSelect = (selectedKeys, info) => {
    // setAllIds(selectedKeys.join(','))
  };

  const onCheck = (checkedKeys, info) => {
    // setAllIds(checkedKeys.join(','))
  };
  return (
    <AddModal
      title={title}
      footer={[
        <Row key={"btn"} span={24}>
          <Button key={1} onClick={handelCancel} className="abuttons">
            <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
          </Button>
          <Button
            key={2}
            loading={loading}
            onClick={submit}
            className="abuttons"
            type="primary"
          >
            <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
          </Button>
        </Row>,
      ]}
      visible={visible}
      width={800}
      okText={"确定"}
      onCancel={handelCancel}
      onSubmit={() => submit()}
    >
      <div className="userModal">
        <Form
          preserve={false}
          {...layout}
          // name="basic"
          // layout="horizontal"
          form={form}
          style={{ marginTop: "20px" }}
          initialValues={formValue}
        >
          <Row>
            {/* <Col span={12}>
              <Form.Item
                label='资源名称'
                name="deptPath"
                rules={[{ required: true, message: '请输入资源名称!' }]}
              >
                <Input disabled={editBool} placeholder={'请输入资源名称'} />
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="角色标识符"
                name="identifier"
                rules={[{ required: true, message: "请输入资源表示符!" }]}
              >
                <Select placeholder="请选择角色标识符" allowClear>
                  {" "}
                  {roleText.map((item) => {
                    return (
                      <Select.Option key={item.dictKey} value={item.dictKey}>
                        {item.dictValue}
                      </Select.Option>
                    );
                  })}
                </Select>
                {/* <Input placeholder={'资源表示符'} /> */}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="角色名称"
                name="name"
                rules={[{ required: true, message: "请输入角色名称" }]}
              >
                <Input placeholder={"请输入角色名称"} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="资源列表"
                name="resourceIds"
                rules={[{ required: true, message: "请选择资源列表!" }]}
              >
                {/* <Input placeholder={'所属平台'} /> */}
                <TreeSelect
                  // {...tProps}
                  treeData={resourceTree && resourceTree[0]}
                  onChange={handleChange}
                  treeCheckable={true}
                  showCheckedStrategy={SHOW_PARENT}
                  placeholder="请选择资源列表"
                  style={{
                    width: "100%",
                  }}
                ></TreeSelect>
                {/* <Tree
                  checkable
                  // defaultExpandedKeys={formValue.resourceIds}
                  // defaultSelectedKeys={['0-0-0', '0-0-1']}
                  // defaultCheckedKeys={['0-0-0', '0-0-1']}
                  onSelect={onSelect}
                  onCheck={onCheck}
                  treeData={resourceTree && resourceTree[0]}
                /> */}
              </Form.Item>
            </Col>
            {/* <Col span={12}>
              <Form.Item label='资源列表' name="resourceIds" rules={[{ required: true, message: '请输入资源列表!' }]}>
                <Input placeholder={'资源列表'} />
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="数据权限"
                name="dataScope"
                rules={[{ required: true, message: "请输入数据权限" }]}
              >
                <Select placeholder="请选择数据权限" allowClear>
                  <Select.Option value={0}>所有数据</Select.Option>
                  <Select.Option value={1}>本部门数据</Select.Option>
                  <Select.Option value={2}>本部门及以下数据</Select.Option>
                  <Select.Option value={3}>仅查看自己的数据</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="角色类型" name="roleType">
                <Radio.Group disabled={editBool} buttonStyle="solid">
                  <Radio.Button value={1}>用户</Radio.Button>
                  <Radio.Button value={2}>运维</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="角色类型" name="type">
                <Radio.Group buttonStyle="solid">
                  <Radio.Button value={1}>领导角色</Radio.Button>
                  <Radio.Button value={2}>业务角色</Radio.Button>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="备注" name="remark">
                <Input.TextArea row={4} placeholder={"备注"} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </AddModal>
  );
};
